package com.qrkontaq.pages

import androidx.compose.runtime.Composable
import com.qrkontaq.core.tenant.Tenant
import com.qrkontaq.ui.admin.PlatformAdminScreen
import com.qrkontaq.ui.landing.LandingPage
import com.qrkontaq.ui.layouts.PageLayout
import com.qrkontaq.ui.sections.about.AboutSection
import com.qrkontaq.ui.sections.contact.ContactSection
import com.qrkontaq.ui.sections.home.HomeSection
import com.qrkontaq.ui.sections.projects.ProjectsSection
import com.qrkontaq.ui.sections.services.ServicesSection
import com.qrkontaq.ui.tenant.MenuScreen
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.Page

@Page("/")
@Composable
fun HomePage() {
    if (Tenant.isPlatformAdminSite) {
        // adminkontaq.qrkontaq.com -> the platform owner's dashboard
        PlatformAdminScreen()
        return
    }

    val tenantSlug = Tenant.slug
    if (tenantSlug != null) {
        // cafename.qrkontaq.com -> the restaurant's menu IS the site root
        MenuScreen(slug = tenantSlug)
        return
    }

    // qrkontaq.com -> platform landing
    LandingPage()
}
